import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes } from 'redux-form';
import moment from 'moment';
import DropdownList from 'react-select';
import { Button  } from '@material-ui/core';
import css from './xpa.css';
import { required } from '../Common/Validation';
import { selectMonth, selectDay, region, entryType } from '../Common/SelectLists';

const validate = values => {
    const errors = {};
    const finDate = `
        ${(typeof values.financialYearStartDay === 'number') ? values.financialYearStartDay : values.financialYearStartDay.value}/
        ${(typeof values.financialYearStartMonth === 'number') ? values.financialYearStartMonth : values.financialYearStartMonth.value}/19`

    if (values.financialYearStartDay && values.financialYearStartMonth) {
        if (!moment(finDate, 'D/M/YY').isValid()) {
        errors.financialYearStartMonth = 'Not a valid date';
        } 
    }
    return errors;
}


const renderField = ({ input, label, meta: { touched, error } }) => (
  <div className={css.dFlex}>
    <label className={css.width200}>{label}</label>
    <input {...input} className={[css.formControl, css.flexWidth].join(' ')} type="text" />
    { touched && (error && <i className={css.validationLabel}>{error}</i>) }
  </div>
);

const renderSelect = ({ input, label, options, ...rest , meta: { touched, error } }) => (
    <div className={css.dFlex}>
        <label className={css.width200}>{label}</label>
        <div className={css.flexWidth}>
            <DropdownList 
            {...input} {...rest} 
            options={options}
            value={options.find(item => item.value === input.value)}
            onBlur={() => input.change}
            menuPlacement="auto"
            />
        </div>
        { touched && (error && <i className={css.validationLabel}>{error}</i>) }
    </div>
  );

  const renderSelectSmall = ({ input, options, label, value, ...rest , meta: { touched, error } }) => (
    <div className={css.dFlex}>
        <div className={css.flexWidth}>
            <DropdownList 
            {...input} {...rest} 
            options={options}
            value={options.find(item => item.value === input.value)}
            placeholder={label}
            onBlur={() => input.change}
            menuPlacement="auto"
            />
        </div>
        { touched && (error && <i className={css.validationLabel}>{error}</i>) }
    </div>
  );


const LedgerForm = (props) => {
    const { handleSubmit } = props;

    return (
            <form onSubmit={handleSubmit}>
                <Field name="bookName" label="Feed Collection" type="text" component={renderField} validate={required} />
                <Field name="entityType" label="Entity Type" type="text" component={renderSelect} options={entryType} validate={required} />
                <Field name="region" label="Region" type="text" component={renderSelect} options={region} validate={required} />
                <div className={css.dFlex}>
                    <label className={css.width200}>Start of Financial Year</label>
                    <div className={[css.width150, css.spaceRight10].join(' ')}><Field name="financialYearStartDay" type="text" component={renderSelectSmall} label="Day" options={selectDay} validate={required} /></div>
                    <div className={css.flexWidth}><Field name="financialYearStartMonth" type="text" component={renderSelectSmall} label="Month" options={selectMonth} validate={required} /></div>
                </div>
                
                <div>
                    <Button type="submit" variant="contained" className={css.spaceRight10} color="primary">Save</Button>
                </div>
                <div className={css.version}>1.04</div>
            </form>
    );
};

LedgerForm.propTypes = {
    ...propTypes,

};

renderField.propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired
};

export default reduxForm({
  form: 'ledgerForm',
  validate
})(LedgerForm);


// WEBPACK FOOTER //
// ./src/components/XPA/LedgerForm.js